// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"910":"a195ef1a","959":"f501434e","970":"70279b85"}[chunkId] + ".chunk.css";
};